import React, { useState } from 'react';
import {
  Row,
  Col,
  Form,
  Input,
  Alert,
  DatePicker,
  Button,
  Space,
  Image,
} from 'antd';
import moment from 'moment';
import { QuestionCircleOutlined } from '@ant-design/icons';
import * as Config from '../../../appConfig';
import { activePeriod, activeMonth } from '../../../utils/date';

const AddPaymentImportForm = ({
  onPaymentImportSubmit,
  onCancelClick,
  UploadFile,
  importErrors,
  ability,
}) => {
  const [form] = Form.useForm();
  const [freezePrevMonth, currentMonth, prevMonth] = activePeriod();
  const [showTemplate, setShowTemplate] = useState(false);

  return (
    <>
      <Form
        form={form}
        layout="vertical"
        size="large"
        className="ant-form-custom"
        initialValues={{}}
        onFinish={(values) =>
          onPaymentImportSubmit(values, (updated) => {
            if (updated.status === 2) {
              // setShowRelieveModal(false);
            }
          })
        }
        style={{ marginTop: '0' }}
      >
        {importErrors && (
          <Row>
            <Col xs={24}>
              <Alert
                message="Import Error"
                description={importErrors}
                type="error"
                style={{ maxHeight: '200px', overflow: 'auto' }}
              />
            </Col>
          </Row>
        )}
        <Row>
          <Col xs={24}>
            <Form.Item
              label="Month"
              name="for_month"
              rules={[
                {
                  required: true,
                  message: 'Please select Month!',
                },
              ]}
            >
              <DatePicker
                disabledDate={(current) => !activeMonth(current, prevMonth)}
                format={Config.DATE_MONTH_INPUT}
                picker="month"
              />
            </Form.Item>
          </Col>
        </Row>
        {/* <Row>
          <Col xs={24}>
            <Form.Item label="Note" name="note">
              <Input placeholder="Note" maxLength="255" />
            </Form.Item>
          </Col>
        </Row> */}
        <Row>
          <Col xs={24}>{UploadFile}</Col>
        </Row>
        <Row>
          <Col xs={24}>
            <Button
              type="link"
              size="small"
              onClick={() => setShowTemplate(true)}
              icon={<QuestionCircleOutlined />}
            >
              Payments import template
            </Button>
            <Image
              width={200}
              style={{ display: 'none' }}
              src={process.env.PUBLIC_URL + '/import-templates/incentives.png'}
              preview={{
                visible: showTemplate,
                src:
                  process.env.PUBLIC_URL + '/import-templates/payments.png',
                onVisibleChange: (value) => {
                  setShowTemplate(value);
                },
              }}
            />
          </Col>
        </Row>
        <Row>
          <Col xs={24} align="right">
            <Space>
              <Button type="secondary" size="middle" onClick={onCancelClick}>
                Cancel
              </Button>
              <Button type="primary" size="middle" htmlType="submit">
                Import
              </Button>
            </Space>
          </Col>
        </Row>
        <Form.Item name="id" hidden>
          <Input />
        </Form.Item>
      </Form>
    </>
  );
};

export default AddPaymentImportForm;
